import { ModalFooter } from 'components/modals/ModalFooter';
import { ModalHeader } from 'components/modals/ModalHeader';
import HandoverNoteInput from 'pages/delegations/HandoverNoteInput';
import { ReactNode, useState } from 'react';
import { t } from 'utils/getTranslations';

interface Props {
    titleId: string;
    labelId: string;
    /** Existing note text to seed the editor (empty when adding a new one). */
    initialValue: string;
    saveId?: string;
    onCancel: () => void;
    /** Called with the trimmed note when the user saves. */
    onSave: (note: string) => void;
}

/**
 * Small modal for editing a delegation case's handover or return note. Reuses the shared timestamped-notes
 * textarea so clicking into it stamps "DD-MM-YYYY (User): " like every other notes field.
 */
const CaseNoteModal = ({ titleId, labelId, initialValue, saveId = 'save', onCancel, onSave }: Props): ReactNode => {
    const [note, setNote] = useState(initialValue);
    const trimmed = note.trim();

    return (
        <>
            <ModalHeader title={t(titleId)} onCancel={onCancel} />
            <div className="flex flex-col gap-4 p-6">
                <HandoverNoteInput label={t(labelId)} minRows={4} value={note} onChange={setNote} />
            </div>
            <ModalFooter
                onCancel={onCancel}
                onSave={() => onSave(trimmed)}
                disableSave={trimmed.length === 0}
                saveButtonTextId={saveId}
                cancelButtonTextId="cancel"
            />
        </>
    );
};

export default CaseNoteModal;
